module.exports = __webpack_public_path__ + "static/media/family-wide.3c0ff26a.png";